import { z } from 'zod';

import { validatePassword } from '@/helpers/validatePassword';

/** Creates a Zod schema for password validation with strength requirements. */
export const password = (required: boolean) =>
  z.string().superRefine((val, ctx) => {
    // Allow empty value when not required
    if (!required && (val == null || val.length === 0)) {
      return;
    }

    const result = validatePassword(val ?? '', { isRequired: required });
    if (!result.isAllowed) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: result.message ?? 'Please improve the strength of this password.',
      });
    }
  });
